///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.report_type = abcsetup.report_type || {};
abcsetup.report_type.run = abcsetup.report_type.run || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.report_type.run = {
    filters: {},

    init: function() {
        $(".clear_filters").click(function() {
            $("#filter_fields input[type=text],#filter_fields input[type=number],#filter_fields select").val("");
            return false;
        });

        $('.filters.btn').on('click', function() {
            $('#apply_filter').show();
            let unindexed_array = $("form#filter_fields").serializeArray();
            let indexed_array = {};

            $.map(unindexed_array, function(n, i) {
                indexed_array[n['name']] = n['value'];
            });

            if (indexed_array) {
                abcsetup.report_type.run.filters = indexed_array;
                abcsetup.report_type.run.run();
            }
        });

        $("select.__CATEGORY__").change(function() {
            const category_id = $(this).val();
            axios.get('/api/front_store/fineline_search', {
                params: {
                    category_id: category_id
                }}).then(response => {
                    if (response.data) {
                        let select_subcategory = $("select.__SUBCATEGORY__");
                        select_subcategory.empty().append($("<option></option>").attr("value","").text("-select-"));
                        $("select.__SEGMENT__").empty().append($("<option></option>").attr("value","").text("-select-"));

                        $.each(response.data[0], function(value,text) {
                            select_subcategory.append($("<option></option>")
                                .attr("value", value).text(text));
                        });

                        let report_filters_by_subs_key = $('#report_filters_by_subs_key').val();
                        console.log('report_filters_by_subs_key: ',report_filters_by_subs_key);

                        if (select_subcategory.find("option[value='"+report_filters_by_subs_key["__SUBCATEGORY__"]+"']").length) {
                            select_subcategory.val(report_filters_by_subs_key["__SUBCATEGORY__"]);
                            $("select.__SUBCATEGORY__").trigger("change");
                        }
                    }

            }).catch(error => {
                abcsetup.dashboard.removeLoading();
            });
        });

        $("select.__SUBCATEGORY__").change(function() {
            const subcategory_id = $(this).val();
            axios.get('/api/front_store/fineline_search', {
                params: {
                    subcategory_id: subcategory_id
                }}).then(response => {
                    if (response.data) {
                        let select_fineline = $("select.__SEGMENT__");

                        select_fineline.empty().append($("<option></option>").attr("value","").text("-select-"));
                        $.each(response.data[0], function(value,text) {
                            select_fineline.append($("<option></option>")
                                .attr("value",value).text(text));
                        });

                        let report_filters_by_subs_key = $('#report_filters_by_subs_key').val();
                        if (select_fineline.find("option[value='"+report_filters_by_subs_key["__SEGMENT__"]+"']").length) {
                            select_fineline.val(report_filters_by_subs_key["__SEGMENT__"]);
                            $("select.__SEGMENT__").trigger("change");
                        }
                    }
            }).catch(error => {
                abcsetup.dashboard.removeLoading();
            });
        });

        // Run the initial page load report
        $('.filters.btn').trigger('click');
    },

    run: function() {
        const report_id = $("#report_id").val();
        const filters = abcsetup.report_type.run.filters;

        abcsetup.report_type.run.showLoading();

        axios.get('/api/report_type/run_report_data/' + report_id, {
            params: {
                filters
              }}).then(response => {
            if (response.data.table_data) {
                $('#apply_filter').hide();
                $('#report_data .dataTables_wrapper').remove();
                $('#report_data').append(response.data.table_data);
                $('#report_data').addClass('table-sm');
                abcsetup.datatables.init($('table#report_type'), {
                    bInfo: true,
                    // scroll_horizontal: true,
                    "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
                    "iDisplayLength": 25,
                    "order": [[1, "desc"]],
                    "responsive": true,
                    "language": {
                        "emptyTable": "Report returns an empty dataset",
                        processing: '<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span> '
                    },
                    "columnDefs": [{
                        "targets": 1,
                        // "orderable": false
                    }],
                    "detectDateCol": 'MM/DD/YYYY hh:mm A'
                });
            }

            abcsetup.report_type.run.removeLoading();
        }).catch(error => {
            abcsetup.dashboard.removeLoading();
        });
    },

    showLoading: function() {
        abcsetup.report_type.run.removeLoading();
        $('#report_panel').find('.breadcrumb').append('<li class="loading"><img src="/img/loading.gif"></li>');
    },

    removeLoading: function() {
        $('#report_panel').find('li.loading').remove();
    },
}
